// from https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript
export default function hashString(str: string) {
  let hash = 0;

  if (str.length === 0) {
    return hash;
  }
  for (let i = 0; i < str.length; i++) {
    const chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
}

/**
 * Hashes an array of strings into a single integer.
 * WARNING: The hash doesn't include any separator between the strings.
 *          Therefore these two arrays will have the same hash:
 *          ["foo", "bar"] and ["foob", "ar"]
 * Use with caution.
 * @param strs - The array of strings to hash.
 * @returns A single integer hash of the array of strings.
 */
export function hashStringArray(strs: string[]) {
  let hash = 0;
  for (let i = 0; i < strs.length; i++) {
    const str = strs[i];
    for (let j = 0; j < str.length; j++) {
      const chr = str.charCodeAt(j);
      hash = (hash << 5) - hash + chr;
      hash |= 0; // Convert to 32bit integer
    }
  }
  return hash;
}
